import { CommonEntrypoint } from "entrypoint/CommonEntrypoint"; 
import 'presentation/style/index.scss'; 
import ChargeTypeMaintenanceCont from "presentation/view/container/ChargeType/ChargeTypeContMain"; 
CommonEntrypoint(<ChargeTypeMaintenanceCont/>) 
